import * as types from "../../mutation-types";

export default {
    [types.SET_CLOCKLOG]: (state, clocklog) => {
        state.clocklog = clocklog
    },
}